import React, { useState, useEffect } from 'react';
import Navbar from '../Template/Navbar';
import Sidebar from '../Template/Sidebar';
import callAPI from '../../commonMethod/api.js';
import Multiselect from "multiselect-react-dropdown";
import Loding from '../Template/Loding';
import { toast } from 'react-toastify';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Cropper from "react-easy-crop";
import { getCroppedImgBlob } from "./cropImage";
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

const EditCreatedMsg = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { id } = location.state;
    const URL = process.env.REACT_APP_URL;
    const token = sessionStorage.getItem('token');
    const [loading, setLoading] = useState(true);
    const [schoolList, setSchoolList] = useState([]);
    const [subgroup, setSubgroup] = useState([]);
    const [number, setNumber] = useState([]);
    const [parentsnumber, setParentsNumber] = useState([]);
    const [inputFields, setInputFields] = useState([]);
    const [datas, setDatas] = useState({ msg_id: '', subject_text: '', show_upto: '', msg_priority: '1', msg_chat_type: '', msg_sgroup_id: '', is_reply_type: 0, is_reply_required_any: 0, is_active: 1, entry_by: 1, edit_by: 1, school_id: [], five_mobile_number: '', message_body: [], })
    const admin_id = sessionStorage.getItem('admin_id');
    const [replyrequired, setReplyrequired] = useState(0);

    useEffect(() => {
        const fetchSendedData = async () => {
            try {
                const response = await callAPI.get(`/msg/get_MessageGroupData/${id}`);
                const val = response.data;
                handleUpdateSchool(val);
            } catch (error) {
                console.error("Error fetching message data:", error);
            }
        };
        fetchSendedData();
    }, [id]);

    const convertUTCToLocalInput = (utcString) => {
        const date = new Date(utcString); // parses UTC ISO string
        const pad = (n) => n.toString().padStart(2, '0');

        const yyyy = date.getFullYear();
        const mm = pad(date.getMonth() + 1);
        const dd = pad(date.getDate());
        const hh = pad(date.getHours());
        const mi = pad(date.getMinutes());

        return `${yyyy}-${mm}-${dd}T${hh}:${mi}`;
    };



    const handleUpdateSchool = (val) => {
        const existingFields = val.data.msg_bodies.map((msg) => {
            const parsedDataText = JSON.parse(msg.data_text);

            let msg_body_id = msg.msg_body_id;
            let title = parsedDataText.title || parsedDataText.text || '';
            let link = parsedDataText.title || parsedDataText.link || '';
            let linkValue = parsedDataText.link || '';
            let placeholder = parsedDataText.placeholder || '';
            let options = parsedDataText.options || '';

            let type = msg.msg_type.split('-')[0];

            if (type === "LINK" || type === "YOUTUBE" || type === "IMAGE" || type === "PDF") {

                title = parsedDataText.title || '';
                link = parsedDataText.link || '';
            } else if (type === "CAMERA" || type === "FILE") {
                title = parsedDataText.title || '';
            }

            return {
                id: Date.now() + Math.random(),
                msg_body_id: msg_body_id,
                type: type,
                title: title,
                link: link,
                options: options,
                placeholder: placeholder,
                linkValue: linkValue,
                isReplyRequired: msg.is_reply_required,
                order: msg.ordersno,
                is_reply_required: msg.is_reply_required,
            };
        });

        const parsedParents = val.data.five_mobile_number
            ? JSON.parse(val.data.five_mobile_number).map((parent) => ({
                student_main_id: parent.student_main_id,
                mobile_no: parent.mobile_no,
            }))
            : [];

        setReplyrequired(val.data.is_reply_required_any)
        setDatas({
            msg_id: val.data.msg_id,
            subject_text: val.data.subject_text || '',
            show_upto: convertUTCToLocalInput(val.data.show_upto) || '',
            msg_priority: val.data.msg_priority || 1,
            msg_chat_type: val.data.msg_chat_type || '',
            msg_sgroup_id: val.data.msg_sgroup_id || '',
            is_reply_type: val.data.is_reply_type || 0,
            is_reply_required_any: val.data.is_reply_required_any,
            is_active: val.data.is_active || 1,
            entry_by: val.data.entry_by || 1,
            edit_by: val.data.edit_by || 1,
            school_id: val.data.schools?.map((val) => val?.sch_id) || [],
            five_mobile_number: parsedParents,
            message_body: val.data.msg_bodies || [],
        });
        setInputFields(existingFields);
        setParentsNumber(parsedParents);
    };

    // const handleInputOptionsChange = (e) => {
    //      const selectedValue = e.target.value;
    //     if (selectedValue === "OPTION" || selectedValue === "CHECKBOX" || selectedValue === "TEXTBOX" || selectedValue === "TEXTAREA" || selectedValue === "CAMERA" || selectedValue === "FILE") {
    //         setReplyrequired(1);
    //     }
    //     const selectedOptions = [...e.target.selectedOptions].map(option => option.value);
    //     const newInputFields = selectedOptions.map(option => ({
    //         id: Date.now() + Math.random(),
    //         type: option,
    //         title: '',
    //         link: '',
    //         options: '',
    //         placeholder: '',
    //     }));
    //     setInputFields([...inputFields, ...newInputFields]);
    //     e.target.value = '';
    // };

    const handleInputOptionsChange = (e) => {
        const selectedOptions = [...e.target.selectedOptions].map(option => option.value);

        // If any selected option is one of the special types, set replyrequired
        if (selectedOptions.some(opt => ["OPTION", "CHECKBOX", "TEXTBOX", "TEXTAREA", "CAMERA", "FILE"].includes(opt))) {
            setReplyrequired(1);
        }

        // Create new input fields
        const newInputFields = selectedOptions.map(option => ({
            id: Date.now() + Math.random(),
            type: option,
            title: '',
            link: '',
            options: '',
            placeholder: '',
        }));

        setInputFields([...inputFields, ...newInputFields]);

        // Clear selection (optional)
        e.target.value = '';
    };




    const handleImageChange = async (e, fieldId) => {
        const formData = new FormData();
        formData.append("file", e.target.files[0]);

        var requestOptions = {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        };
        try {
            const fetchdata = await axios.post(
                `${URL}/v1/admin/imageUpload_Use/imageUpload`,
                formData,
                requestOptions
            );
            if (fetchdata.status === 200) {
                toast.success("Image uploaded successfully");
                const imageUrl = fetchdata.data.url;
                const updatedFields = inputFields.map((field) =>
                    field.id === fieldId ? { ...field, link: imageUrl } : field
                );
                setInputFields(updatedFields);
            } else {
                toast.error("Failed to upload image");
            }
        } catch (error) {
            toast.error("An error occurred during the upload.");
            console.error("Error uploading image:", error);
        }
    };


    const handlePdfUpload = async (e, fieldId) => {
        const formData = new FormData();
        formData.append("file", e.target.files[0]);

        try {
            const res = await axios.post(
                `${URL}/v1/admin/pdfUpload_Use/pdfUpload`,
                formData,
                { headers: { "Content-Type": "multipart/form-data" } }
            );

            if (res.status === 200) {
                toast.success("PDF uploaded successfully");
                const pdfUrl = res.data.url;

                const updatedFields = inputFields.map((field) =>
                    field.id === fieldId ? { ...field, link: pdfUrl } : field
                );
                setInputFields(updatedFields);
            }
        } catch (error) {
            toast.error("PDF upload failed");
            console.error(error);
        }
    };


    // const handleImageChange = (e, fieldId) => {
    //     if (e.target.files && e.target.files.length > 0) {
    //         const file = e.target.files[0];
    //         const reader = new FileReader();
    //         reader.onload = () => {
    //             const updatedFields = inputFields.map((f) =>
    //                 f.id === fieldId ? { ...f, tempImage: reader.result } : f
    //             );
    //             setInputFields(updatedFields);
    //         };
    //         reader.readAsDataURL(file);
    //     }
    // };


    const deleteField = (id) => {
        setInputFields(inputFields.filter(field => field.id !== id));
    };

    const fetchUser = async () => {
        try {
            const response = await fetch(`${URL}/admin/getSingleAdmin/${admin_id}`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
            });
            const data = await response.json();
            if (response.ok) {
                setSchoolList(data.data.allSchoolDetails || []);
                // const combinedAdminIds = [
                //     data.data.admin_id,
                //     ...(data.data?.subordinateDetails?.map((val) => val.admin_id) || []),
                // ];


                // setUser(combinedAdminIds);
            } else {
                console.log('')
            }
        } catch (error) {
            console.error('Error fetching admin details:', error);
        }
    };

    useEffect(() => {
        fetchUser();
    }, []); // eslint-disable-next-line react-hooks/exhaustive-deps


    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                const response = await callAPI.get(`/school/getSchool?page=1&limit=200`);
                const responsetwo = await callAPI.get(`/msg/getSubGroupDetail?page=1&limit=200`);
                const responsethree = await callAPI.get(`/scholar/get_MainList_ScholarDetail`);
                // setSchoolList(response.data.data || []);
                setSubgroup(responsetwo.data.data || []);
                setNumber(responsethree.data.data || []);
            } catch (error) {
                console.error('Error fetching school data:', error.message);
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, []);// eslint-disable-next-line react-hooks/exhaustive-deps

    // const handleChange = (e) => {
    //     const { name, value } = e.target;
    //     setDatas((prev) => ({
    //         ...prev,
    //         [name]: name === 'show_upto' ? new Date(value).toISOString() : value,
    //     }));
    // };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setDatas((prev) => ({
            ...prev,
            [name]: value, // ✅ Keep "2025-07-25T12:35" as-is
        }));
    };


    const formatDateTime = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        return `${year}-${month}-${day}T${hours}:${minutes}`; // Format as YYYY-MM-DDTHH:mm
    };


    const handleUpdate = async (e) => {
        e.preventDefault();
        const messageBody = inputFields.map((field, index) => {

            let dataText = {};
            switch (field.type) {
                case 'TITLE':
                    dataText = { title: field.title || '' };
                    break;
                case 'TEXT':
                    dataText = { text: field.title || '' };
                    break;
                case 'LINK':
                    dataText = { title: field.title || '', link: field.link || '' };
                    break;
                case 'YOUTUBE':
                    dataText = { title: field.title || '', link: field.link || '' };
                    break;
                case 'IMAGE':
                    dataText = { title: field.title || '', link: field.link || '' };
                    break;
                case 'PDF':
                    dataText = { title: field.title || '', link: field.link || '' };
                    break;

                case 'OPTION':
                    dataText = { title: field.title || '', options: field.options || '' };
                    break;
                case 'CHECKBOX':
                    dataText = { title: field.title || '', options: field.options || '' };
                    break;
                case 'TEXTBOX':
                    dataText = { title: field.title || '', placeholder: field.placeholder || '' };
                    break;
                case 'TEXTAREA':
                    dataText = { title: field.title || '', placeholder: field.placeholder || '' };
                    break;
                default:
                    break;
            }
            return {
                msg_body_id: field?.msg_body_id,
                msg_type: `${field.type}-${datas?.msg_chat_type}`,
                data_text: JSON.stringify(dataText),
                order_number: index + 1,
                is_reply_required: field.is_reply_required ? 1 : 0,
            };
        });
        try {
            const response = await callAPI.put(`./msg/updateMessageGroupData/`, {
                msg_id: datas.msg_id,
                subject_text: datas.subject_text,
                show_upto: datas.show_upto,
                msg_priority: datas.msg_priority,
                msg_chat_type: datas.msg_chat_type,
                msg_sgroup_id: datas.msg_sgroup_id,
                is_reply_type: datas.is_reply_type,
                is_reply_required_any: replyrequired,
                is_active: datas.is_active,
                entry_by: datas.entry_by,
                edit_by: parseInt(admin_id),
                school_id: datas.school_id,
                five_mobile_number: parentsnumber,
                message_body: messageBody,
                createdAt: Date.now()
            });
            if (response.status >= 200 && response.status < 300) {
                toast.success('Message updated successfully');
                navigate(-1);
            } else {
                toast.error(response.message);
            }
        } catch (error) {
            console.error('Error submitting form:', error);
            toast.error('An error occurred while submitting the form');
        }
    };

    //geting
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    const minDate = tomorrow.toISOString().split('T')[0]; // Get tomorrow's date in YYYY-MM-DD format

    if (loading) {
        return <Loding />;
    }


    const onDragEnd = (result) => {
        const { destination, source } = result;
        if (!destination) return;

        // Reordering logic
        const items = Array.from(inputFields);
        const [removed] = items.splice(source.index, 1);
        items.splice(destination.index, 0, removed);

        setInputFields(items);
    };



    return (
        <>
            <div className="container-scroller">
                {/*----- Navbar -----*/}
                <Navbar />
                <div className="container-fluid page-body-wrapper">
                    {/* SideBar */}
                    <Sidebar />
                    <div className="main-panel">
                        <div className="content-wrapper">
                            <div className="row">

                                <div className="col-12 grid-margin stretch-card">
                                    <div className="card shadow-sm">
                                        <div className="card-body">
                                            <div className="d-flex align-items-center mb-2">
                                                <h4 className="card-title mb-0 mr-2">New Message</h4>
                                                <p className="text-danger font-weight-bold mb-0">NEW</p>
                                            </div>
                                            <h5 className="card-description text-primary font-weight-bolder mt-3">General Info</h5>
                                            <form className="forms-sample" onSubmit={handleUpdate}>
                                                <div className="row">
                                                    <div className="col-md-4 form-group">
                                                        <label htmlFor="msgCategory">
                                                            Message Category<span className="text-danger"></span>
                                                        </label>
                                                        {/* message category here  */}
                                                        <div className="">
                                                            <label className="text-danger">{datas?.msg_chat_type}</label>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* ................................................upper div............................................ */}

                                                <div className="row">
                                                    <div className="col-md-4 form-group">
                                                        <label htmlFor="subjectLine">Subject Line<span className="text-danger">*</span></label>
                                                        <input type="text" className="form-control" id="subjectLine" placeholder="Subject Line" required name='subject_text' value={datas?.subject_text} onChange={handleChange} />
                                                    </div>

                                                    <div className="col-md-4 form-group">
                                                        <label htmlFor="priority">Priority (1-High)<span className="text-danger">*</span></label>
                                                        <select className="form-control" id="priority" name='msg_priority' required value={datas?.msg_priority} onChange={handleChange}>
                                                            {[...Array(10).keys()].map((val) => (
                                                                <option key={val + 1}>{val + 1}</option>
                                                            ))}
                                                        </select>
                                                    </div>

                                                    <div className="col-md-4 form-group">
                                                        <label htmlFor="showUpto">
                                                            Show Upto Date & Time <span className="text-danger">*</span>
                                                        </label>
                                                        <input
                                                            type="datetime-local"
                                                            className="form-control"
                                                            id="showUpto"
                                                            name="show_upto"
                                                            value={datas?.show_upto ? formatDateTime(datas.show_upto) : ''}
                                                            onChange={handleChange}
                                                            required
                                                            min={minDate}
                                                        />
                                                    </div>



                                                    <div className="col-md-4 form-group">
                                                        <label htmlFor="schools">Schools<span className="text-danger">*</span></label>
                                                        <Multiselect
                                                            className="inputHead"
                                                            selectedValues={
                                                                schoolList.filter(school =>
                                                                    datas.school_id?.includes(school.sch_id)
                                                                )
                                                            }
                                                            onRemove={(event) => {
                                                                const updatedSchoolIds = datas.school_id.filter(id =>
                                                                    !event.some(removed => removed.sch_id === id)
                                                                );
                                                                setDatas(prev => ({ ...prev, school_id: updatedSchoolIds }));
                                                            }}
                                                            onSelect={(event) => {
                                                                const selectedSchoolIds = event.map(selected => selected.sch_id);
                                                                setDatas(prev => ({ ...prev, school_id: selectedSchoolIds }));
                                                            }}
                                                            required
                                                            options={schoolList}
                                                            displayValue="sch_nm"
                                                            showCheckbox
                                                        />
                                                    </div>

                                                    <div className="col-md-4 form-group">
                                                        <label htmlFor="msgCategory">Group/Sub Group<span className="text-danger">*</span></label>
                                                        <select
                                                            className="form-control"
                                                            id="msgCategory"
                                                            name="msg_sgroup_id"
                                                            value={datas.msg_sgroup_id}
                                                            onChange={handleChange}
                                                        >
                                                            <option value="">Select Group/Sub Group</option>
                                                            {subgroup?.map((val, index) => (
                                                                <option key={index} value={val?.msg_sgroup_id}>
                                                                    {val?.msg_group_mst?.msg_group_name} - {val?.msg_sgroup_name}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>


                                                    {datas?.msg_chat_type !== "INPUT" && datas?.msg_chat_type !== "DISPLAY" && (
                                                        <div className="col-md-4 form-group">
                                                            <label htmlFor="msgCategory">
                                                                Add Student <span className="text-danger">(don’t select more than 5 numbers)</span>
                                                            </label>
                                                            <Multiselect
                                                                className="inputHead"
                                                                onRemove={(event) => {
                                                                    const updatedParents = parentsnumber.filter(parent =>
                                                                        !event.some(removed => removed.student_family_mobile_number === parent.mobile_no)
                                                                    );
                                                                    setParentsNumber(updatedParents);
                                                                }}
                                                                onSelect={(event) => {
                                                                    if (event.length <= 5) {
                                                                        const newParents = event.map(num => ({
                                                                            student_main_id: num.student_number,
                                                                            mobile_no: parseInt(num.student_family_mobile_number, 10)
                                                                        }));
                                                                        setParentsNumber(newParents);
                                                                    } else {
                                                                        alert("You can only select a maximum of 5 numbers.");
                                                                    }
                                                                }}
                                                                options={number}
                                                                displayValue="student_family_mobile_number"
                                                                selectedValues={number.filter(student =>
                                                                    parentsnumber.some(parent => parent.mobile_no === parseInt(student.student_family_mobile_number, 10))
                                                                )}
                                                                showCheckbox
                                                            />
                                                        </div>
                                                    )}
                                                </div>

                                                {/* ................................................upper div............................................ */}

                                                <div className="row">

                                                    <div className="col-md-6 form-group">
                                                        <label htmlFor="inputOptions">Chat Options</label>
                                                        <select className="form-control" id="inputOptions" onChange={handleInputOptionsChange}>
                                                            <option value="" selected>Select Options</option>

                                                            <option value="" disabled></option>
                                                            <hr className='py-3' />
                                                            <option value="" disabled></option>
                                                            <option value="TITLE">Title Display</option>
                                                            <option value="TEXT">Text Display</option>
                                                            <option value="LINK">Link Display</option>
                                                            <option value="YOUTUBE">Youtube Display</option>
                                                            <option value="IMAGE">Image Display</option>
                                                            <option value="PDF">PDF Display</option>

                                                            <option value="" disabled></option>

                                                            {datas?.msg_chat_type === 'DISPLAY' ? ''

                                                                : (<>
                                                                    <hr className='py-3' />
                                                                    <option value="" disabled></option>
                                                                    <option value="OPTION">Option Input</option>
                                                                    <option value="CHECKBOX">Checkbox Input</option>
                                                                    <option value="TEXTBOX">Textbox Input</option>
                                                                    <option value="TEXTAREA">Textarea Input</option>
                                                                    <option value="CAMERA">Camera Input</option>
                                                                    <option value="FILE">File Input</option>
                                                                </>)}
                                                        </select>
                                                    </div>
                                                </div>

                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <DragDropContext onDragEnd={onDragEnd}>
                                                            <Droppable droppableId="droppable">
                                                                {(provided) => (
                                                                    <div
                                                                        className="col-12"
                                                                        ref={provided.innerRef}
                                                                        {...provided.droppableProps}
                                                                    >
                                                                        {inputFields.map((field, index) => (
                                                                            <Draggable key={field.id} draggableId={field.id.toString()} index={index}>
                                                                                {(provided) => (
                                                                                    <div
                                                                                        className="col-12 form-group"
                                                                                        ref={provided.innerRef}
                                                                                        {...provided.draggableProps}
                                                                                        {...provided.dragHandleProps}
                                                                                    >
                                                                                        <label>{field.type}</label>
                                                                                        <div className="d-flex flex-column align-items-start">


                                                                                            <input
                                                                                                type="text"
                                                                                                className="form-control mb-2"
                                                                                                placeholder={`Enter title for ${field.type}`}
                                                                                                value={field.title || ''} // Display previous value
                                                                                                onChange={(e) => {
                                                                                                    const updatedFields = inputFields.map((f) =>
                                                                                                        f.id === field.id ? { ...f, title: e.target.value } : f
                                                                                                    );
                                                                                                    setInputFields(updatedFields);
                                                                                                }}
                                                                                            />

                                                                                            {field.type === 'LINK' && (

                                                                                                <input
                                                                                                    type="text"
                                                                                                    className="form-control mb-2"
                                                                                                    placeholder={`Enter ${field.type === 'LINK' ? 'Link' : 'YouTube URL'}`}
                                                                                                    value={field.link || ''}
                                                                                                    onChange={(e) => {
                                                                                                        const updatedFields = inputFields.map((f) =>
                                                                                                            f.id === field.id ? { ...f, link: e.target.value } : f
                                                                                                        );
                                                                                                        setInputFields(updatedFields);
                                                                                                    }}
                                                                                                />

                                                                                            )}

                                                                                            {field.type === 'YOUTUBE' && (

                                                                                                <input
                                                                                                    type="text"
                                                                                                    className="form-control mb-2"
                                                                                                    placeholder={`Enter ${field.type === 'LINK' ? 'Link' : 'YouTube URL'}`}
                                                                                                    value={field.link || ''}
                                                                                                    onChange={(e) => {
                                                                                                        const updatedFields = inputFields.map((f) =>
                                                                                                            f.id === field.id ? { ...f, link: e.target.value } : f
                                                                                                        );
                                                                                                        setInputFields(updatedFields);
                                                                                                    }}
                                                                                                />

                                                                                            )}



                                                                                            {(field.type === 'OPTION' || field.type === 'CHECKBOX') && (
                                                                                                <input
                                                                                                    type="text"
                                                                                                    className="form-control mb-2"
                                                                                                    placeholder={`Enter options for ${field.type} (e.g. Option1;Option2)`}
                                                                                                    value={field.options || ''} // Display previous options
                                                                                                    onChange={(e) => {
                                                                                                        const updatedFields = inputFields.map((f) =>
                                                                                                            f.id === field.id ? { ...f, options: e.target.value } : f
                                                                                                        );
                                                                                                        setInputFields(updatedFields);
                                                                                                    }}
                                                                                                />
                                                                                            )}

                                                                                            {field.type === "TEXTBOX" && (
                                                                                                <textarea
                                                                                                    className="form-control mb-2"
                                                                                                    placeholder="Enter placeholder for Textbox"
                                                                                                    value={field.placeholder || ""}
                                                                                                    rows={1}
                                                                                                    onInput={(e) => {
                                                                                                        e.target.style.height = "auto"; // Reset height
                                                                                                        e.target.style.height = e.target.scrollHeight + "px"; // Adjust dynamically
                                                                                                    }}
                                                                                                    onChange={(e) => {
                                                                                                        const updatedFields = inputFields.map((f) =>
                                                                                                            f.id === field.id ? { ...f, placeholder: e.target.value } : f
                                                                                                        );
                                                                                                        setInputFields(updatedFields);
                                                                                                    }}
                                                                                                    style={{
                                                                                                        overflow: "hidden",
                                                                                                        resize: "none",
                                                                                                        minHeight: "38px", // Matches input field height
                                                                                                    }}
                                                                                                />
                                                                                            )}


                                                                                            {field.type === "TEXTAREA" && (
                                                                                                <textarea
                                                                                                    className="form-control mb-2"
                                                                                                    placeholder="Enter placeholder for Textarea"
                                                                                                    value={field.placeholder || ""}
                                                                                                    rows={1}
                                                                                                    onInput={(e) => {
                                                                                                        e.target.style.height = "auto"; // Reset height
                                                                                                        e.target.style.height = e.target.scrollHeight + "px"; // Expand dynamically
                                                                                                    }}
                                                                                                    onChange={(e) => {
                                                                                                        const updatedFields = inputFields.map((f) =>
                                                                                                            f.id === field.id ? { ...f, placeholder: e.target.value } : f
                                                                                                        );
                                                                                                        setInputFields(updatedFields);
                                                                                                    }}
                                                                                                    style={{
                                                                                                        overflow: "hidden",
                                                                                                        resize: "none",
                                                                                                        minHeight: "38px", // Matches normal input height
                                                                                                    }}
                                                                                                />
                                                                                            )}


                                                                                            {field.type === 'IMAGE' && (
                                                                                                <>
                                                                                                    <input
                                                                                                        type="text"
                                                                                                        className="form-control mb-2"
                                                                                                        placeholder={`Enter ${field.type} URL`}
                                                                                                        value={field.link || ''}
                                                                                                        onChange={(e) => {
                                                                                                            const updatedFields = inputFields.map((f) =>
                                                                                                                f.id === field.id ? { ...f, link: e.target.value } : f
                                                                                                            );
                                                                                                            setInputFields(updatedFields);
                                                                                                        }}
                                                                                                    />
                                                                                                    <input
                                                                                                        type="file"
                                                                                                        className="form-control"
                                                                                                        accept="image/*"
                                                                                                        onChange={(e) => handleImageChange(e, field.id)}
                                                                                                    />
                                                                                                </>
                                                                                            )}



                                                                                            {field.type === 'PDF' && (
                                                                                                <>
                                                                                                    <input
                                                                                                        type="text"
                                                                                                        className="form-control mb-2"
                                                                                                        placeholder="Enter PDF URL"
                                                                                                        value={field.link || ''}
                                                                                                        onChange={(e) => {
                                                                                                            const updatedFields = inputFields.map((f) =>
                                                                                                                f.id === field.id ? { ...f, link: e.target.value } : f
                                                                                                            );
                                                                                                            setInputFields(updatedFields);
                                                                                                        }}
                                                                                                    />

                                                                                                    <input
                                                                                                        type="file"
                                                                                                        className="form-control"
                                                                                                        accept="application/pdf"
                                                                                                        onChange={(e) => handlePdfUpload(e, field.id)}
                                                                                                    />

                                                                                                    {field.link && (
                                                                                                        <iframe
                                                                                                            src={field.link}
                                                                                                            width="100%"
                                                                                                            height="200"
                                                                                                            title="PDF Preview"
                                                                                                            style={{ marginTop: "8px", border: "1px solid #ccc" }}
                                                                                                        />
                                                                                                    )}
                                                                                                </>
                                                                                            )}



                                                                                            {(field.type === "OPTION" || field.type === "CHECKBOX" || field.type === "TEXTBOX" || field.type === "TEXTAREA" || field.type === "CAMERA" || field.type === "FILE") && (
                                                                                                <div className="form-check">
                                                                                                    <input
                                                                                                        type="checkbox"
                                                                                                        className="form-check-input"
                                                                                                        checked={field.is_reply_required}
                                                                                                        onChange={(e) => {
                                                                                                            const updatedFields = inputFields.map((f) =>
                                                                                                                f.id === field.id ? { ...f, is_reply_required: e.target.checked } : f
                                                                                                            );
                                                                                                            setInputFields(updatedFields);
                                                                                                        }}
                                                                                                    />
                                                                                                    <label className="form-check-label">Reply Required</label>
                                                                                                </div>
                                                                                            )}

                                                                                            <button type="button" className="btn border-0 mt-2" onClick={() => deleteField(field.id)}>
                                                                                                <i className="fa-solid fa-trash-can text-danger"></i>
                                                                                            </button>
                                                                                        </div>
                                                                                    </div>
                                                                                )}
                                                                            </Draggable>
                                                                        ))}
                                                                        {provided.placeholder}
                                                                    </div>
                                                                )}
                                                            </Droppable>
                                                        </DragDropContext>
                                                    </div>
                                                </div>

                                                <button type="submit" className="btn btn-primary mr-2">Submit</button>
                                            </form>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default EditCreatedMsg